import React from 'react';
import './Hero.css';

const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="hero">
      <div className="hero-container">
        <div className="hero-content">
          <h1 className="hero-title">
            Conectamos la
            <span className="gradient-text"> Innovación</span>
            <br />
            con tu Éxito Exponencial
          </h1>
          <p className="hero-subtitle">
            Diseñamos el futuro de los negocios. Somos un consorcio tecnológico especializado en crear 
            soluciones digitales inteligentes que potencian a emprendedores, PYMEs y organizaciones 
            en su camino hacia la innovación y transformación digital impulsada con Inteligencia Artificial Generativa.
          </p>
          <div className="hero-buttons">
            <button 
              className="btn btn-primary"
              onClick={() => scrollToSection('contacto')}
            >
              Comenzar Ahora
            </button>
            <button 
              className="btn btn-secondary"
              onClick={() => scrollToSection('servicios')}
            >
              Conocer Más
            </button>
          </div>
        </div>
        <div className="hero-visual">
          <div className="logo-visual">
            <img 
              src="/images/isotipo.png"
              alt="Innexia Isotipo"
              className="isotipo-floating"
            />
          </div>
        </div>
      </div>
      <div className="hero-wave">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M0,60 Q300,100 600,60 T1200,60 L1200,120 L0,120 Z" fill="var(--gray-50)"/>
        </svg>
      </div>
    </section>
  );
};

export default Hero;

